<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template v-if="showHeader">
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <v-row class="mt-10">
        <v-col class="d-flex pt-0">
          <img
            src="../../assets/icons/sorts/resource_center.png"
            class="tcdc-resource-center-layout-icon mr-4"
          />
          <span class="text-tcdc-green bold header text-uppercase">resource center</span>
        </v-col>
      </v-row>
      <v-row id="ebooks-list">
        <v-col>
          <span class="text-tcdc-green bold header bold text-uppercase">{{$t('ebook.ebook')}}</span>
        </v-col>
      </v-row>
    </template>
    <div v-if="allEbooks && allEbooks.length > 0">
      <v-row>
        <template v-for="item of allEbooks">
          <v-col cols="12" sm="6" md="4" :key="item.id.toString()">
            <EbookCard
                    class="cursor-pointer"
                    :image="item.cover_img_path  && item.cover_img_path!= '' ? item.cover_img_path : book_defalut"
                    :title="item[`subject_${lang}`]"
                    :description="item[`intro_${lang}`]"
                    :date="item[`article_date_${lang}`]"
                    :viewer="item.count_download"
                    @click.native="ebookHandler(item.article_id, item.slug)"
            />
          </v-col>
        </template>
      </v-row>
      <v-row class="mt-8">
        <v-col class="d-flex align-center justify-end">
          <v-pagination
                  v-if="ebookPages"
                  total-visible="7"
                  v-model="ebookPages.current_page"
                  :length="ebookPages.last_page"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  color="#2e8037"
                  @input="(event) => {changePage(event); $vuetify.goTo('#ebooks-list');}"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
    <div v-else class="grey--text my-5">
      <div class="text-center">
        {{$t('ebook.noAnyItem')}}
      </div>
    </div>
  </div>
</template>

<script>
import EbookCard from "../../components/cards/EbookCard";
import GreenButton from "../../components/buttons/GreenButton";
import {mapState} from "vuex";
import Loading from 'vue-loading-overlay';
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";
import {Utils} from "@/util/Utils";
import book_defalut from "@/assets/book-default.jpg"
export default {
  components: {
    EbookCard,
    Loading
  },
  props: {
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
    if (!this.ebookPages) {
      this.isLoading = true;
      await this.$store.dispatch('Article/onGetAllEbooks', { page: 1, lang: this.lang })
      .then(()=>{
        this.isLoading = false;
      });
    }
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      ebookPages: state => state.Article.allEbooks,
      allEbooks: state => {
        if (state.Article.allEbooks) {
          return state.Article.allEbooks.data
        }
      }
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchName,
          this.allBranches,
          this.lang
      )
    }
  },
  data: () => ({
    book_defalut: book_defalut,
    isLoading: false,
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        disabled: false,
        to: "/:branch/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/:branch/service/resource-center"
      },
      {
        text: "E-BOOK",
        disabled: true
      }
    ]
  }),
  methods: {
    ebookHandler(id, slug) {
      const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
      this.$router.push(`/${this.lang}`+`${branch}/service/resource-center/e-book/${id}-${slug}`);
    },
    changePage(page) {
      this.isLoading = true;
      this.$store.dispatch('Article/onGetAllEbooks', { page: page, lang: this.lang })
              .then(()=>{
                this.isLoading = false;
              });
    }
  },
  mounted() {
    // console.log('xx',this.allEbooks)
  },
};
</script>

<style>
</style>
